import { useEffect } from "react";

import { useState } from "react";
import Course from "../../models/Course";
import { ParticipantData } from "../../models/Participant";
import {
  Dialog,
  Box,
  Typography,
  Tabs,
  Tab,
  Grid2 as Grid,
  TextField,
  Button,
} from "@mui/material";
import { formatDate } from "../../shared/helperFunctions";
import courseService from "../../services/courseService";

// Participant Details Component
const ParticipantDetailsDialog = ({
  participant,
  open,
  onClose,
}: {
  participant: ParticipantData;
  open: boolean;
  onClose: () => void;
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [courses, setCourses] = useState<Course[]>([]);

  useEffect(() => {
    // Replace with your API call
    const fetchParticipantCourses = async () => {
      try {
        const response = await courseService.fetchCoursesForParticipant(
          participant.id
        );
        setCourses(response);
      } catch (error) {
        console.error("Error fetching participant courses:", error);
      }
    };

    if (open) {
      fetchParticipantCourses();
    }
  }, [participant.id, open]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Participant Details
        </Typography>

        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Details" />
          <Tab label="Courses" />
        </Tabs>

        <Box sx={{ mt: 2 }}>
          {activeTab === 0 ? (
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="First Name"
                  value={participant.firstName}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Last Name"
                  value={participant.lastName}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Email"
                  value={participant.email}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Organization"
                  value={participant.organization}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Position"
                  value={participant.positionTitle}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  value={participant.phoneNumber}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>
          ) : (
            <Box>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        borderBottom: "1px solid #ccc",
                        textAlign: "left",
                        padding: "8px",
                      }}
                    >
                      Course
                    </th>
                    <th
                      style={{
                        borderBottom: "1px solid #ccc",
                        textAlign: "left",
                        padding: "8px",
                      }}
                    >
                      Start Date
                    </th>
                    <th
                      style={{
                        borderBottom: "1px solid #ccc",
                        textAlign: "left",
                        padding: "8px",
                      }}
                    >
                      Location
                    </th>
                    <th
                      style={{
                        borderBottom: "1px solid #ccc",
                        textAlign: "left",
                        padding: "8px",
                      }}
                    >
                      Instructor
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {courses.map((course) => (
                    <tr key={course.id}>
                      <td style={{ padding: "8px" }}>{course.name}</td>
                      <td style={{ padding: "8px" }}>
                        {course.startDate
                          ? new Date(course.startDate).toLocaleDateString(
                              undefined,
                              {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                              }
                            )
                          : "-"}
                      </td>
                      <td style={{ padding: "8px" }}>
                        {course.location || "-"}
                      </td>
                      <td style={{ padding: "8px" }}>
                        {course.pointOfContact || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          )}
        </Box>

        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Close</Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ParticipantDetailsDialog;
